import { Vue, Component } from 'vue-property-decorator'
import { MetaInfo } from 'vue-meta'
import LinkItem from '~/types/LinkItem'
import PageHeader from '~/components/page/PageHeader'
import HeaderType from '~/types/enum/HeaderType'
import DiseaseSectionIconList from '~/components/block/DiseaseSectionIconList'
import DiseaseSectionList from '~/components/block/DiseaseSectionList'
import DiseaseFilter from '~/components/block/DiseaseFilter'
import DiseaseItem from '~/components/block/DiseaseItem'
import LinkPaginate from '~/components/element/LinkPaginate'
import SeoTextBlock from '~/components/block/SeoTextBlock'
import loc from '~/utils/loc'
import s from '~/utils/s'
import mainBreadcrumbsSubmenuItems from '~/utils/mainBreadcrumbsSubmenuItems'

@Component({
  components: {
    DiseaseItem
  },
  head () {
    return {
      link: [
        {
          rel: 'canonical',
          href: `https://${s(this.$store).general.host}/${s(this.$store).regions.sectionCode}/diseases/`
        }
      ]
    } as MetaInfo
  }
})
export default class DiseasesPage extends Vue {
  async mounted () {
    const regionId = s(this.$store).regions.regionId
    const sectionId = s(this.$store).regions.sectionId
    await s(this.$store).staticPages.getStaticPage({ code: 'diseases', regionId, sectionId })
    const staticPage = s(this.$store).staticPages.staticPage
    if (staticPage && staticPage.code === 'diseases') {
      s(this.$store).seo.setTitle(staticPage.SEOTitle)
      s(this.$store).seo.setDescription(staticPage.SEODescription)
      s(this.$store).seo.setKeywords(staticPage.SEOKeywords)
    }
  }

  get breadcrumb (): LinkItem[] {
    return [
      {
        title: 'Главная',
        location: loc(this.$store, { name: 'index' }),
        submenuItems: mainBreadcrumbsSubmenuItems(this.$store)
      },
      {
        title: 'Справочник заболеваний',
        location: loc(this.$store, {
          name: 'diseases'
        })
      }
    ]
  }

  get topSections () {
    return s(this.$store).diseasesPage.sections.filter(e => e.icon)
  }

  get isShowPaginate (): boolean {
    return s(this.$store).diseasesPage.pageCount > 1
  }

  get ferchLocation () {
    const targetPage = s(this.$store).diseasesPage.page + 2
    const query = this.$route.query
    return {
      path: this.$route.path,
      query: {
        ...query,
        page: targetPage.toString()
      }
    }
  }

  async redirectToPage404() {
    await s(this.$store).general.redirectNotFound()
  }

  renderPaginate () {
    if (this.isShowPaginate) {
      return (
        <div class="diseases-page__content-paginate">
          <LinkPaginate {...{
            props: {
              pageCount: s(this.$store).diseasesPage.pageCount,
              selected: s(this.$store).diseasesPage.page
            }
          }} />
        </div>
      )
    }
  }

  renderLoadButton () {
    if (s(this.$store).diseasesPage.page < s(this.$store).diseasesPage.pageCount - 1) {
      return (
        <div class="diseases-page__content-fetch">
          <nuxt-link {...{
            class: 'diseases-page__content-fetch-button',
            props: {
              to: this.ferchLocation
            },
            nativeOn: {
              click: () => s(this.$store).diseasesPage.enableLoadMore()
            }
          }}>
            Загрузить еще
          </nuxt-link>
        </div>
      )
    }
  }

  renderItems () {
    if (s(this.$store).diseasesPage.list.items) {
      return (
        <div class="diseases-page__col-list">
          <div class="diseases-page__filter">
            <DiseaseFilter {...{
              props: {
                activeLetters: s(this.$store).diseasesPage.list.filterFirstLetters ?? []
              }
            }} />
          </div>
          <div class="diseases-page__list">
            {s(this.$store).diseasesPage.list.items.map(e => (
              <disease-item {...{
                props: {
                  item: e
                },
                key: e.id
              }} />
            ))}
          </div>
          <div class="diseases-page__navigation">
            <div class="diseases-page__navigation-row">
              <div class="diseases-page__navigation-fetch-col">
                {this.renderLoadButton()}
              </div>
              <div class='diseases-page__navigation-page-col'>
                {this.renderPaginate()}
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      this.redirectToPage404()
    }
  }

  render () {
    return (
      <div class="diseases-page">
        <div class="diseases-page__header">
          <PageHeader {...{
            props: {
              typeHeader: HeaderType.Diseases,
              breadcrumb: this.breadcrumb
            }
          }} />
        </div>
        <div class="diseases-page__content">
          {this.topSections.length > 0 &&
            <div class="diseases-page__content-top">
              <DiseaseSectionIconList {...{
                props: {
                  items: this.topSections
                }
              }} />
              <div class="diseases-page__content-top-line"></div>
            </div>
          }
          <div class="diseases-page__row">
            <div class="diseases-page__col-sections">
              <div class="diseases-page__sections-title">
                Разделы медицины
              </div>
              <div class="diseases-page__sections-list">
                <DiseaseSectionList {...{
                  props: {
                    items: s(this.$store).diseasesPage.sections
                  }
                }} />
              </div>
            </div>
            {this.renderItems()}
          </div>
        </div>
        <SeoTextBlock />
      </div>
    )
  }
}
